import React, { useMemo } from 'react';
import { Icon } from '@oneaudi/unified-web-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ContactDealerCta, CtaGroupMobileWrapper, StyledTextButton } from './ButtonGroups.styles';
import { PromotionType } from '../../../types/offers';
import { parseDigitalLeadsData } from '../../../utils/digitalLeadsFormat';
import { selectZipCode } from '../../../reducers/zipCodeReducer';

type ButtonGroupsProps = {
  offer: PromotionType;
  confirmedZipcode: string;
  inventoryUrl: string;
  dealerId?: string;
};

const ButtonGroups: React.FC<ButtonGroupsProps> = ({
  offer,
  confirmedZipcode,
  inventoryUrl,
  dealerId,
}) => {
  const { t } = useTranslation();

  const { market } = useSelector(selectZipCode);

  const isCaMarket = market === 'CA';

  const digitalLeadsInfo = useMemo(() => {
    const dataInfo = parseDigitalLeadsData(offer, isCaMarket, confirmedZipcode, dealerId);
    return dataInfo;
  }, [confirmedZipcode, dealerId, offer, isCaMarket]);

  const ViewInventoryButton = useMemo(() => {
    return (
      <StyledTextButton
        data-testid="featured-offer-inventory-cta"
        href={inventoryUrl}
        variant="tertiary"
        size="sm"
        className="aa"
        target="_blank"
        icon="external-link"
        iconPosition="trailing"
      >
        {t('promo.offers.cta.inventory')}
      </StyledTextButton>
    );
  }, [inventoryUrl, t]);

  const renderCTAs = useMemo(() => {
    return (
      <>
        {ViewInventoryButton}
        <ContactDealerCta
          id="digital-leads"
          data-info={digitalLeadsInfo}
          data-testid="featured-offer-details-contact-cta"
        >
          {t('promo.offers.cta.contact')}
          <Icon name="forward-active" size="s" />
        </ContactDealerCta>
      </>
    );
  }, [ViewInventoryButton, digitalLeadsInfo, t]);

  return <CtaGroupMobileWrapper isCaMarket={isCaMarket}>{renderCTAs}</CtaGroupMobileWrapper>;
};

export default ButtonGroups;
